import * as React from 'react';
import {
  Datagrid,
  List,
  ListProps,
  TextField,
  useGetIdentity,
  useTranslate,
} from 'react-admin';
import TestTypeField from '../../../components/Fields/TestTypeField';
import PartnerField from '../../../components/Fields/PartnerField';
import Paginator from '../../../components/Paginator';
import { TESTS_PER_PAGE } from '../../../constants/pagination';

import './styles.scss';

const FertilityCheckList = (props: ListProps) => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const isAdmin = identity?.userRoles?.includes('admin');
  const isFertilityDoctor = identity?.userRoles?.includes('fertilityDoctor');

  if (!isAdmin && !isFertilityDoctor) {
    return null;
  }

  return (
    <List
      {...props}
      bulkActionButtons={false}
      actions={false}
      empty={<div className="error">{translate('testResults.noTests')}</div>}
      pagination={<Paginator perPage={TESTS_PER_PAGE} />}
      perPage={TESTS_PER_PAGE}
    >
      <Datagrid rowClick="show">
        <TestTypeField source="type" label="tests.type" />
        <TextField
          sortable={false}
          emptyText="-"
          source="code"
          label="tests.code"
        />
        {isAdmin && (
          <PartnerField source="partnerCode" label="tests.columns.partners" />
        )}
      </Datagrid>
    </List>
  );
};

export default FertilityCheckList;
